import { defineSlotRecipe } from '@chakra-ui/react';
import { fieldsetAnatomy } from '@chakra-ui/react/anatomy';

export const fieldsetRecipe = defineSlotRecipe({
  className: 'ac-fieldset',
  slots: fieldsetAnatomy.keys(),
  base: {
    root: {
      border: 'none',
      padding: '0px',
      margin: '0px',
      maxWidth: '100%',
      minWidth: '0px',

      _notFirst: {
        marginTop: '16px',
      },
    },
    legend: {
      fontWeight: 600,
      padding: 0,
      margin: 0,
      color: 'grey.dark.2',
      fontSize: '15px',
      letterSpacing: '0.15px',
      lineHeight: '20px',
    },
  },
  variants: {
    notFirst: {
      true: {
        root: {
          marginTop: '16px',
        },
      },
    },
    variant: {
      subsection: {
        root: {},
        legend: {
          fontSize: '14px',
          fontWeight: 'normal',
          borderBottom: '1px solid {colors.halton.blue}',
          paddingBottom: '5px',
          marginBottom: '15px',
        },
      },
      project: {
        root: {
          display: 'flex',
          justifyContent: 'flex-start',
          flexDirection: 'column',
          alignItems: 'stretch',
        },
      },
    },
  },
  defaultVariants: {
    variant: 'project',
  },
});
